import React from 'react';
import Svg, { Path, Ellipse, Circle } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const CareTeam: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M20.269 29.905c0 5.396-4.314 7.106-9.635 7.106C5.314 37.01 1 35.3 1 29.905c0-5.395 4.313-9.77 9.634-9.77 5.321 0 9.635 4.375 9.635 9.77z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Ellipse
                cx={10.6342}
                cy={15.1354}
                rx={6.62364}
                ry={6.87511}
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Path
                d="M6.106 9.606c-.193-.758.22-1.492.908-1.663 2.374-.59 4.822-.59 7.196 0 .686.17 1.1.905.908 1.663l-.301 1.184c-.215.846-1.153 1.377-2.127 1.208a12.164 12.164 0 00-4.157 0c-.974.169-1.911-.362-2.126-1.208l-.301-1.184z"
                fill="#fff"
                stroke={props.color}
            />
            <Path
                d="M58 29.905c0 5.396-4.314 7.106-9.635 7.106-5.32 0-9.634-1.71-9.634-7.106 0-5.395 4.313-9.77 9.634-9.77 5.321 0 9.635 4.375 9.635 9.77z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Ellipse
                cx={48.3653}
                cy={15.1354}
                rx={6.62364}
                ry={6.87511}
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Ellipse cx={44.6267} cy={26.9538} rx={1.67165} ry={1.73511} fill="#fff" stroke={props.color} />
            <Path
                d="M44.627 21.748v3.47M54.657 29.383c0-2.3-1.123-4.164-2.508-4.164s-2.507 1.864-2.507 4.164M52.15 21.748v3.47"
                stroke={props.color}
                strokeLinecap="round"
            />
            <Path
                d="M42.14 42.368c0 3.325-1.349 5.406-3.495 6.712-2.225 1.355-5.4 1.93-9.075 1.93-3.676 0-6.85-.575-9.076-1.93C18.348 47.775 17 45.694 17 42.368c0-6.747 5.605-12.257 12.57-12.257 6.964 0 12.57 5.51 12.57 12.257z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Circle cx={29.5695} cy={23.3263} r={8.32907} fill="#fff" stroke={props.color} strokeWidth={2} />
            <Path stroke={props.color} d="M37 19.5L23 19.5" />
            <Circle cx={30} cy={17} r={3.5} fill="#fff" stroke={props.color} />
        </Svg>
    );
};

export default React.memo(CareTeam);
